import React from 'react';
import { mediaUrl } from '../api/client';

function initials(name) {
  if (!name) return '?';
  const parts = name.trim().split(/\s+/).slice(0, 2);
  return parts.map(w => w[0]).join('').toUpperCase();
}

export default function Avatar({ src, name, size = 40, color = 'var(--signal)' }) {
  const url = mediaUrl(src);
  if (url) {
    return (
      <img
        src={url}
        alt={name || ''}
        style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover', border: '1px solid var(--line)', flexShrink: 0 }}
      />
    );
  }
  return (
    <div style={{
      width: size, height: size, borderRadius: '50%', background: color, color: '#fff',
      display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700,
      fontSize: Math.max(10, size * 0.36), flexShrink: 0, fontFamily: 'var(--font-display)'
    }}>
      {initials(name)}
    </div>
  );
}
